import { useEffect, useRef } from 'react';

// Using this hides the Navigation bar. Also includes reverting back of the hidden Navigation bar.
export default function useHideNavbar() {
  const navCtasRef = useRef(document.getElementById('nav-ctas'));

  useEffect(() => {
    if (!navCtasRef.current) return;

    navCtasRef.current?.classList.add('hidden');

    return () => {
      navCtasRef.current?.classList.remove('hidden');
    };
  }, []);
}
